module.exports = __webpack_public_path__ + "img/icon-delete.67282f93.svg";